module.exports = __webpack_public_path__ + "static/qvbc-logo-31023e4fbd814c5b5477c7fa73ea001c.png";